export default __webpack_public_path__ + "images/rosabandet/breast-cancer/icon-clock.png";